import * as React from "react";
const Calendar = props => <symbol viewBox="0 0 24 24" {...props}>
    <g>
      <path d="M19 3.25h-2.25V2a.75.75 0 10-1.5 0v1.25h-6.5V2a.75.75 0 00-1.5 0v1.25H5A2.753 2.753 0 002.25 6v13A2.753 2.753 0 005 21.75h14A2.753 2.753 0 0021.75 19V6A2.753 2.753 0 0019 3.25zM5 4.75h2.25V6a.75.75 0 001.5 0V4.75h6.5V6a.75.75 0 101.5 0V4.75H19A1.251 1.251 0 0120.25 6v2.25H3.75V6A1.251 1.251 0 015 4.75zm14 15.5H5A1.25 1.25 0 013.75 19V9.75h16.5V19A1.25 1.25 0 0119 20.25z" />
      <path d="M12.016 11.979h-.006a1.002 1.002 0 10.006 0zm5 0h-.006a1.002 1.002 0 10.006 0zm-10.002 4h-.007a1.003 1.003 0 10.007 0zm5 0h-.007a1.003 1.003 0 10.007 0z" />
    </g>
  </symbol>;
export default Calendar;